import React, {useEffect, useState} from 'react';
import {StyleSheet, Text} from 'react-native';
import {IRequest} from 'src/domains';
import {Banner, BannerLayout} from './Banner';
import {colors} from 'src/assets';
import {minutesToTime, secondsToTime} from '../utils';
import {useCallActions} from 'src/hooks';
import LocalText from 'src/local';

export type TalkBlockProps = {
  call: IRequest;
};

export const TalkBlock: React.FC<TalkBlockProps> = ({call}) => {
  const [countDown, setCountDown] = useState<string>('');
  const [countUp, setCountUp] = useState<string>('');
  const [maxTime, setMaxTime] = useState<string>('');
  const {finishCall} = useCallActions();

  useEffect(() => {
    let interval = setInterval(() => {
      if (!call.startedAt || !call.maxTalkingTimeBefore) {
        clearInterval(interval);
        return;
      }
      const startedAt = new Date(call.startedAt);
      const maxTalkingTimeBeforeAt = new Date(call.maxTalkingTimeBefore);
      const countUpDiff = Date.now() - startedAt.getTime();
      const countDownDiff =
        maxTalkingTimeBeforeAt.getTime() -
        Date.now() +
        (call.freeTime || 0) * 1000;
      if (countDownDiff < 0) {
        clearInterval(interval);
        setCountDown(secondsToTime(0));
        setCountUp(maxTime);
        finishCall({id: call.id});
        return;
      }
      setCountUp(
        secondsToTime(countUpDiff > 0 ? Math.round(countUpDiff / 1000) : 0),
      );
      setCountDown(
        secondsToTime(countDownDiff > 0 ? Math.round(countDownDiff / 1000) : 0),
      );
    }, 1000);

    if (call.startedAt && call.maxTalkingTimeBefore) {
      const startedAt = new Date(call.startedAt);
      const maxTalkingTimeBeforeAt = new Date(call.maxTalkingTimeBefore);
      const maxTimeDiff =
        maxTalkingTimeBeforeAt.getTime() - startedAt.getTime();
      setMaxTime(secondsToTime(Math.round(maxTimeDiff / 1000)));
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [call]);
  return (
    <React.Fragment>
      <Banner
        containerStyle={styles.banner}
        layout={BannerLayout.TalkTime}
        time={countUp}
        maxTime={maxTime}
      />
      <Banner
        containerStyle={styles.banner}
        layout={BannerLayout.TalkRemain}
        countDown={countDown}
      />
      <Text style={styles.description}>
        {LocalText.screens.call.talkBlock.description}
      </Text>
    </React.Fragment>
  );
};

const styles = StyleSheet.create({
  banner: {
    marginHorizontal: 16,
    marginVertical: 8,
  },
  description: {
    marginHorizontal: 16,
    marginVertical: 8,
    fontSize: 12,
    color: colors.chokuBlack,
    lineHeight: 13,
  },
});
